import React from "react";
import styles from "./pro-button.less";

interface ButtonProps extends React.PropsWithChildren {
    isFocus?: boolean;
    delayFocus?: number;
    classname: string;
    text: string;
    colorscheme: string;
    size: string;
    iconType: string;
    icon: string;
    iconPosition?: string;
    download: string;
    downloadUrl: string;
    data?: string;
    features?: string;
    variant?: string;
    shape?: string;
    disabled?: boolean;
    onClick?: (ev: any) => void;
}

const Button = (props: ButtonProps) => {
    const ddl = props.data && (
        <span className="button-text">{props.text && props.text} 333</span>
    );

    const icononly = !props.data && props.icon && !props.text && (
        <div className="icon-only">
            <i className={`fa ${props.iconType} fa-${props.icon}`} aria-hidden="true"  ></i>
        </div>
    );

    const icontext = !props.data && props.icon && props.text && (
        <span className={!props.text ? `` : `icon-wrapper`}>
            <i className={`fa ${props.iconType} fa-${props.icon}`} aria-hidden="true" ></i>
        </span>
    );

    const textonly = !props.data && (
        <span className="button-text">{props.text && props.text}</span>
    );

    const btncontent = (
        <div className={`btncontent ${props.iconPosition && props.iconPosition} `}>
            {icononly}
            {icontext}
            {textonly}
            {ddl}
        </div>
    );

    return ( 
        <button
            rel='noreferrer'
            disabled={props.disabled}
            ref={(btn) => {
                if (props.isFocus) { 
                    setTimeout(() => btn?.focus(), props.delayFocus ?? 0);
                }
            }}
           className={`pro-button
            ${props.classname && props.classname}
            ${props.size && props.size} 
            ${props.colorscheme && props.colorscheme}
            ${props.shape && props.shape} 
            ${props.iconPosition && props.iconPosition} 
            ${props.variant && props.variant} 
            ${styles.proButton} 
            `}
            onClick={props.downloadUrl === "#" || props.downloadUrl === "" ? props.onClick : () => { window.open(props.downloadUrl, "_blank", props.features) }}
        >{btncontent}</button>
    );
};

export default Button;
